module.exports = __webpack_public_path__ + "static/media/Horni_ctvrte.d6715134.md";